<template>
    <div>
        <DFormRow
            :label="__('customers.contracts.notes.internal')"
            :error="errors.notes_internal"
        >
            <DFormTextarea
                id="notes_internal"
                :model-value="notesInternal"
                rows="5"
                @update:modelValue="$emit('update:notesInternal', $event)"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.contracts.notes.invoice')"
            :error="errors.notes_invoice"
        >
            <DFormTextarea
                id="notes_invoice"
                :model-value="notesInvoice"
                rows="5"
                @update:modelValue="$emit('update:notesInvoice', $event)"
            />
        </DFormRow>
    </div>
</template>

<script>
export default {
    name: 'Notes',
    props: {
        notesInternal: {
            type: String,
            default: null
        },
        notesInvoice: {
            type: String,
            default: null
        },
        errors: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['update:notesInternal', 'update:notesInvoice']
}
</script>
